import { useState, useEffect, useCallback } from 'react';
import { DefaultSizeMap } from '../constants/breakpoints';
var getBreakPoint = function (props) {
    if (props === void 0) { props = {}; }
    // const xxlBPoint = props?.xxl || DefaultSizeMap.xxl
    var xlBPoint = (props === null || props === void 0 ? void 0 : props.xl) || DefaultSizeMap.xl;
    var lgBPoint = (props === null || props === void 0 ? void 0 : props.lg) || DefaultSizeMap.l;
    var mdBPoint = (props === null || props === void 0 ? void 0 : props.md) || DefaultSizeMap.md;
    var smBPoint = (props === null || props === void 0 ? void 0 : props.sm) || DefaultSizeMap.sm;
    if (window.matchMedia("(min-width: ".concat(smBPoint, ") and (max-width: ").concat(mdBPoint, ")")).matches) {
        // if(window.matchMedia(`(min-width: ${smBPoint}) and (max-width: ${smBPoint})`).matches) {
        //     return 'xsm'
        // }
        return 'sm';
    }
    if (window.matchMedia("(min-width: ".concat(mdBPoint, ") and (max-width: ").concat(lgBPoint, ")")).matches) {
        return 'md';
    }
    if (window.matchMedia("(min-width: ".concat(lgBPoint, ") and (max-width: ").concat(xlBPoint, ")")).matches) {
        return 'lg';
    }
    if (window.matchMedia("(min-width: ".concat(xlBPoint, ")")).matches) {
        return 'xl';
    }
    return 'xsm';
};
/**
 * кастомный хук следящий за брейкпоинтами ресайза и отдающий одно из 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xsm'.
 * Дефолтные брейкпоинты { xxl: '1440px', xl: '1200px', lg: '992px', md: '743px', sm: '576px' } могут быть заменены на пользовательские.
 */
export var useMediaQuery = function (props) {
    if (props === void 0) { props = {}; }
    var initBreakPoint = getBreakPoint(null);
    var _a = useState(initBreakPoint), breakPoint = _a[0], setBreakPoint = _a[1];
    var resizeCallback = useCallback(function () {
        var newBreakPoint = getBreakPoint(props);
        setBreakPoint(newBreakPoint);
    }, [props]);
    useEffect(function () {
        window.addEventListener('resize', resizeCallback);
        return function () { return window.removeEventListener('resize', resizeCallback); };
    }, []);
    return { breakPoint: breakPoint };
};
//# sourceMappingURL=useMediaQuery.js.mapimport { useState, useEffect, useCallback } from 'react';
import { DefaultSizeMap } from '../constants/breakpoints';
var getBreakPoint = function (props) {
    if (props === void 0) { props = {}; }
    // const xxlBPoint = props?.xxl || DefaultSizeMap.xxl
    var xlBPoint = (props === null || props === void 0 ? void 0 : props.xl) || DefaultSizeMap.xl;
    var lgBPoint = (props === null || props === void 0 ? void 0 : props.lg) || DefaultSizeMap.l;
    var mdBPoint = (props === null || props === void 0 ? void 0 : props.md) || DefaultSizeMap.md;
    var smBPoint = (props === null || props === void 0 ? void 0 : props.sm) || DefaultSizeMap.sm;
    if (window.matchMedia("(min-width: ".concat(smBPoint, ") and (max-width: ").concat(mdBPoint, ")")).matches) {
        // if(window.matchMedia(`(min-width: ${smBPoint}) and (max-width: ${smBPoint})`).matches) {
        //     return 'xsm'
        // }
        return 'sm';
    }
    if (window.matchMedia("(min-width: ".concat(mdBPoint, ") and (max-width: ").concat(lgBPoint, ")")).matches) {
        return 'md';
    }
    if (window.matchMedia("(min-width: ".concat(lgBPoint, ") and (max-width: ").concat(xlBPoint, ")")).matches) {
        return 'lg';
    }
    if (window.matchMedia("(min-width: ".concat(xlBPoint, ")")).matches) {
        return 'xl';
    }
    return 'xsm';
};
/**
 * кастомный хук следящий за брейкпоинтами ресайза и отдающий одно из 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xsm'.
 * Дефолтные брейкпоинты { xxl: '1440px', xl: '1200px', lg: '992px', md: '743px', sm: '576px' } могут быть заменены на пользовательские.
 */
export var useMediaQuery = function (props) {
    if (props === void 0) { props = {}; }
    var initBreakPoint = getBreakPoint(null);
    var _a = useState(initBreakPoint), breakPoint = _a[0], setBreakPoint = _a[1];
    var resizeCallback = useCallback(function () {
        var newBreakPoint = getBreakPoint(props);
        setBreakPoint(newBreakPoint);
    }, [props]);
    useEffect(function () {
        window.addEventListener('resize', resizeCallback);
        return function () { return window.removeEventListener('resize', resizeCallback); };
    }, []);
    return { breakPoint: breakPoint };
};
//# sourceMappingURL=useMediaQuery.js.map